// Author yjb
// Date 2021-11-13 20:42:08

class ImfSicEquipmentInfoIsei {
constructor({
        id = null,
        iseiCode = '',
        iseiName = '',
        iseiModel = '',
        iseiType = '',
        iseiPrdDate = '',
        iseiSys = '',
        iseiMonDate = '',
        iseiMonLocation = '',
        iseiPrdFac = '',
        iseiPrdCode = '',
        iseiSecurityCertificateNo = '',
        iseiExplosionProofCertificateNo = '',
        iseiRatedVoltage = '',
        iseiRatedCurrent = '',
        iseiRatedPower = '',
        remark = ''}
= {}) {
    this.id = id;
    this.iseiCode = iseiCode;
    this.iseiName = iseiName;
    this.iseiModel = iseiModel;
    this.iseiType = iseiType;
    this.iseiPrdDate = iseiPrdDate;
    this.iseiSys = iseiSys;
    this.iseiMonDate = iseiMonDate;
    this.iseiMonLocation = iseiMonLocation;
    this.iseiPrdFac = iseiPrdFac;
    this.iseiPrdCode = iseiPrdCode;
    this.iseiSecurityCertificateNo = iseiSecurityCertificateNo;
    this.iseiExplosionProofCertificateNo = iseiExplosionProofCertificateNo;
    this.iseiRatedVoltage = iseiRatedVoltage;
    this.iseiRatedCurrent = iseiRatedCurrent;
    this.iseiRatedPower = iseiRatedPower;
    this.remark = remark;
}
}

function newEntity() {
return new ImfSicEquipmentInfoIsei();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiCode',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiName',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiModel',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiModel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiType',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiPrdDate',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiPrdDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiSys',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiSys',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiMonDate',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiMonDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiMonLocation',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiMonLocation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiPrdFac',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiPrdFac',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiPrdCode',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiPrdCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiSecurityCertificateNo',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiSecurityCertificateNo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiExplosionProofCertificateNo',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiExplosionProofCertificateNo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiRatedVoltage',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiRatedVoltage',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiRatedCurrent',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiRatedCurrent',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iseiRatedPower',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.iseiRatedPower',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    iseiCodeFilter : '',
    iseiNameFilter : '',
    iseiModelFilter : '',
    iseiTypeFilter : '',
    iseiPrdDateRteFilter : '',
    iseiPrdDateLteFilter : '',
    iseiSysFilter : '',
    iseiMonDateRteFilter : '',
    iseiMonDateLteFilter : '',
    iseiMonLocationFilter : '',
    iseiPrdFacFilter : '',
    iseiPrdCodeFilter : '',
    iseiSecurityCertificateNoFilter : '',
    iseiExplosionProofCertificateNoFilter : '',
    iseiRatedVoltageFilter : '',
    iseiRatedCurrentFilter : '',
    iseiRatedPowerFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'iseiCodeFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiNameFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiModelFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiModel',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiTypeFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiType',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iseiPrdDateRteFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiPrdDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'iseiPrdDateLteFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiPrdDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'iseiSysFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiSys',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiMonDateRteFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiMonDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'iseiMonDateLteFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiMonDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'iseiMonLocationFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiMonLocation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiPrdFacFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiPrdFac',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiPrdCodeFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiPrdCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiSecurityCertificateNoFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiSecurityCertificateNo',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiExplosionProofCertificateNoFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiExplosionProofCertificateNo',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiRatedVoltageFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiRatedVoltage',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iseiRatedCurrentFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiRatedCurrent',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iseiRatedPowerFilter',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.filter.iseiRatedPower',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'iseiCode',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiName',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiModel',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiModel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiType',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiType',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iseiPrdDate',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiPrdDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'iseiSys',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiSys',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiMonDate',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiMonDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'iseiMonLocation',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiMonLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiPrdFac',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiPrdFac',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiPrdCode',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiPrdCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiSecurityCertificateNo',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiSecurityCertificateNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiExplosionProofCertificateNo',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiExplosionProofCertificateNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iseiRatedVoltage',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiRatedVoltage',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iseiRatedCurrent',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiRatedCurrent',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iseiRatedPower',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.iseiRatedPower',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.imfSicEquipmentInfoIsei.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfSicEquipmentInfoIsei, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
